import ReactRailsUJS from 'react_ujs';
import "core-js/stable";
import "regenerator-runtime/runtime";
import "focus-visible"; // needed for accessibility, allows html element outline for keyboard navigation, while hiding outline for mouse interactions
import 'url-polyfill'; // needed for IE11, polyfills native API URL and URLSearchParams


ReactRailsUJS.useContext(require.context('components', true));
